<template>
    <div
        :class="`floor-component flex ${floorHeaderClass} py-1 lg:py-3 ${classNames}`"
        :style="{
            transition: 'transform 300ms',
            height: layout === 'horizontal' && !isMobile ? '80px' : '',
            ...style,
        }"
        @click="switchFloorToCurrent()"
    >
        <div class="floor-title mx-8 text-center">
            <button
                :class="`${layout === 'vertical' ? '' : 'hidden'} lg:hidden`"
                @click.stop="back()"
            >
                Vissza
            </button>
            <h2 class="text-center whitespace-nowrap">{{ title }}</h2>
        </div>
        <div :class="`floor flex ${layout} ${floorLayoutClass} justify-center items-end`">
            <div class="southside">
                <h3 class="text-center">Dél</h3>
                <div :class="`flex ${sideLayoutClass}`">
                    <RoomComponent
                        v-for="room in rooms.south"
                        :key="room.roomNumber"
                        :number="room.roomNumber"
                        :width="room.width"
                        :clickable="room.clickable"
                        :size="size"
                        :layout="layout"
                    />
                </div>
            </div>
            <div class="corridor">
                <div :class="`flex ${sideLayoutClass}`">
                    <RoomComponent
                        v-for="room in rooms.corridor"
                        :key="room.roomNumber"
                        :number="room.roomNumber"
                        :width="room.width"
                        :clickable="room.clickable"
                        :size="size"
                        :layout="layout"
                        :corridor="true"
                    />
                </div>
            </div>
            <div class="northside">
                <h3 class="text-center">Észak</h3>
                <div :class="`flex ${sideLayoutClass}`">
                    <RoomComponent
                        v-for="room in rooms.north"
                        :key="room.roomNumber"
                        :number="room.roomNumber"
                        :width="room.width"
                        :clickable="room.clickable"
                        :size="size"
                        :layout="layout"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RoomComponent from './RoomComponent';
import { mapActions } from 'vuex';

export default {
    name: 'FloorComponent',
    components: { RoomComponent },
    props: ['id', 'rooms', 'size', 'layout', 'style', 'classNames'],
    computed: {
        title() {
            return this.id === '0' ? 'Földszint' : `${this.id}. emelet`;
        },
        sideLayoutClass() {
            return this.layout === 'vertical' ? 'flex-col' : 'flex-row';
        },
        floorHeaderClass() {
            return this.layout === 'vertical' ? 'flex-col' : 'flex-col lg:flex-row items-center';
        },
        floorLayoutClass() {
            return this.layout === 'vertical' ? 'flex-row mobile:w-1/5' : 'flex-col-reverse';
        },
        isMobile() {
            // TODO: remove this & i know its a shit
            return window.matchMedia('(max-width: 1024px)').matches;
        },
    },
    methods: {
        ...mapActions('Room', ['switchFloor', 'switchView']),
        back() {
            this.switchView('dorm');
        },
        switchFloorToCurrent() {
            this.switchFloor(this.id);
        },
    },
};
</script>

<style scoped>
@media (min-width: 1024px) {
    .floor-component.active h2 {
        font-weight: 900;
    }
}

.floor.horizontal .northside .room-component:first-of-type,
.floor.vertical .southside .room-component:first-of-type {
    border-top-left-radius: 8px;
}
.floor.horizontal .northside .room-component:last-of-type,
.floor.vertical .northside .room-component:first-of-type {
    border-top-right-radius: 8px;
}

.floor.horizontal .southside .room-component:first-of-type,
.floor.vertical .southside .room-component:last-of-type {
    border-bottom-left-radius: 8px;
}
.floor.horizontal .southside .room-component:last-of-type,
.floor.vertical .northside .room-component:last-of-type {
    border-bottom-right-radius: 8px;
}

.floor.horizontal {
    transform: rotateX(65deg) rotateY(10deg) rotateZ(-25deg);
    transform-style: preserve-3d;
    border-radius: 8px;
    box-shadow: -1px 1px 0 2px hsla(var(--floor-plate) / 0.84),
        -1px 0 28px 0 hsla(var(--floor-backlight) / 0.01),
        -28px 28px 28px 0 hsla(var(--floor-backlight) / 0.25);
    transition: 0.25s ease-in-out transform, 0.25s ease-in-out box-shadow;
}

@media (min-width: 1280px) {
    .floor-component {
        max-width: 90%;
    }
}
.floor-component:hover {
    transform: scale(1.05);
}

.floor-component:hover .floor.horizontal {
    transform: scale(1.05) translate3d(0px, -10px, 0px) rotateX(65deg) rotateY(10deg)
        rotateZ(-25deg);
    box-shadow: -1px 1px 0 2px hsla(var(--floor-plate) / 0.84),
        -1px 0 28px 0 hsla(var(--floor-backlight) / 0.01),
        -48px 48px 28px -10px hsla(var(--floor-backlight) / 0.15);
}

.floor.horizontal h3 {
    transform: skew(-45deg);
    max-height: 0;
    overflow: hidden;
}
</style>
